import {isEmpty} from "@helpers/helpers";

const $positions = {
    'north': 'شمالی',
    'south': 'جنوبی',
    'north_south': 'شمالی و جنوبی',
    'east': 'شرقی',
    'west': 'غربی',
    'east_west': 'شرقی و غربی',
    'double_edge': 'دو نبش',
    'double_entrance': 'دو ممر',
    'triple_edge': 'سه نبش',
    'triple_entrance': 'سه ممر',
};

export const getPositions = (position = null) => {
    let positions = '';
    if (isEmpty(position)) {
        positions = $positions;
    } else if (typeof position === "string" && !isEmpty($positions[position])) {
        positions = $positions[position];
    } else if (typeof position === "object" && position.length) {
        positions = [];
        for (let item of position) {
            if (!isEmpty($positions[item])) {
                positions.push($positions[item]);
            }
        }
    }

    return positions;
};